import { render } from "./ActiveCertModal.vue?vue&type=template&id=46b6397c&scoped=true"
import script from "./ActiveCertModal.vue?vue&type=script&lang=js"
export * from "./ActiveCertModal.vue?vue&type=script&lang=js"

import "./ActiveCertModal.vue?vue&type=style&index=0&id=46b6397c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b6397c"]])

export default __exports__